"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomField = void 0;
const EditorFieldBase_1 = require("./EditorFieldBase");
class CustomField extends EditorFieldBase_1.EditorFieldBase {
}
exports.CustomField = CustomField;
